import queryString from "query-string";

export default function generateQueryPath(path, query, options = {}) {
	return `${path}?${queryString.stringify(query, options)}`;
}
